import api from '@/services/api'
import { ref } from 'vue'
import { useTheme } from 'vuetify'

// Estado reactivo compartido entre todos los componentes (singleton de módulo)
const _logoUrl = ref(null)

// Inicializar desde localStorage para evitar flash al cargar
try {
    const cached = localStorage.getItem('appTheme')
    if (cached) _logoUrl.value = JSON.parse(cached).logo_url ?? null
} catch { /* silencioso */ }

export const useAppTheme = () => {
    const vuetifyTheme = useTheme()

    const applyTheme = theme => {
        if (!theme) return

        const root = document.documentElement

        // Nav color: si hay color de empresa úsalo, si no adapta al modo
        if (theme.nav_color) {
            root.style.setProperty('--nav-color', theme.nav_color)
        } else {
            root.style.removeProperty('--nav-color')
        }

        if (theme.header_color) root.style.setProperty('--header-color', theme.header_color)

        if (theme.primary_color) {
            vuetifyTheme.themes.value.light.colors.primary = theme.primary_color
            vuetifyTheme.themes.value.dark.colors.primary = theme.primary_color
        }

        // Actualizar logo reactivo
        _logoUrl.value = theme.logo_url ?? null

        localStorage.setItem('appTheme', JSON.stringify(theme))
    }

    const loadTheme = async () => {
        // Aplica cache primero para evitar flash
        const cached = localStorage.getItem('appTheme')
        if (cached) applyTheme(JSON.parse(cached))

        // Sincroniza con backend
        try {
            const { data } = await api.get('/companies/theme')
            if (data.data) applyTheme(data.data)
        } catch { /* silencioso */ }
    }

    return { applyTheme, loadTheme, logoUrl: _logoUrl }
}
